import repository from '@/repositories/repository'
const resource = 'units'
export default {
  export () {
    return repository.get(`${resource}/export`)
  },
  import ({ data, columns, unique }) {
    return repository.post(`${resource}/import`, { data, columns, unique })
  },
  countExport () {
    return repository.get(`${resource}/export/count`)
  },
}
